/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui core
 */
import Paper from '@material-ui/core/Paper';
import Tabel from '@material-ui/core/Table';
import TabelHead from '@material-ui/core/TableHead';
import TabelBody from '@material-ui/core/TableBody';

/**
 * import components
 */
import CameraTableHeadRow from './camera-table-head-row';
import CameraTableBodyRow from './camera-table-body-row';

const CameraTable = (props) => {
  const { list = [], selectedIdx = -1, handleCameraListRowSelected } = props || {};
  return (
    <Paper>
      <Tabel>
        <TabelHead>
          <CameraTableHeadRow />
        </TabelHead>
        <TabelBody>
          {
            list.map(({ ui = {}, ref: uuid, ...rest }, rIdx) => {
              const { isAssigned } = ui;
              const isSelected = (selectedIdx === rIdx);
              const props = { rIdx, isSelected, isAssigned, handleCameraListRowSelected, uuid, ...rest };
              return (
                <CameraTableBodyRow key={rIdx} {...props} />
              );
            })
          }
        </TabelBody>
      </Tabel>
    </Paper>
  );
};
 
CameraTable.propTypes = {
  list: PropTypes.array.isRequired,
  selectedIdx: PropTypes.number.isRequired,
  handleCameraListRowSelected: PropTypes.func.isRequired  
};

export default React.memo(CameraTable);